import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Github, Twitter, Linkedin, Mail, ArrowUpRight, Code2 } from 'lucide-react'

const footerLinks = {
  'Labs': [
    { label: 'The Archive', path: '/archive' },
    { label: 'The Decode', path: '/decode' },
    { label: 'The Forge', path: '/forge' },
  ],
  'Resources': [
    { label: 'Documentation', path: '#' },
    { label: 'API Reference', path: '#' },
    { label: 'GitHub', path: 'https://github.com/quantalgolabs' },
  ],
  'About': [
    { label: 'Our Process', path: '#' },
    { label: 'Blog', path: '#' },
    { label: 'Contact', path: 'mailto:hello@quantalgolabs.org' },
  ],
}

const socialLinks = [
  { icon: Github, href: 'https://github.com/quantalgolabs', label: 'GitHub' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Mail, href: 'mailto:hello@quantalgolabs.org', label: 'Email' },
]

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-ink-border bg-ink-card">
      <div className="section-base section-pad-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Brand — takes more space, editorial feel */}
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-9 h-9 rounded border border-copper/40 flex items-center justify-center text-copper font-bold text-sm font-mono tracking-wider">
                QA
              </div>
              <span className="font-display font-bold text-lg tracking-tight text-cream">
                Quant<span className="text-copper">Algo</span>Labs
              </span>
            </Link>
            <p className="text-cream-muted text-sm leading-relaxed max-w-sm mb-8">
              We turn cutting-edge research papers, social media platforms, and original innovations into production-ready code with full documentation, GitHub references, and live demos.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-9 h-9 rounded border border-cream-dim/30 flex items-center justify-center text-cream-muted hover:text-cream hover:border-cream-dark/50 transition-colors duration-300"
                  aria-label={social.label}
                >
                  <social.icon size={15} />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title} className="lg:col-span-2">
              <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-cream-dark mb-5">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-cream-muted hover:text-cream transition-colors duration-300 inline-flex items-center gap-1 group"
                    >
                      {link.label}
                      <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom — asymmetric, minimal */}
        <div className="mt-20 pt-8 border-t border-ink-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs font-mono text-cream-dark tracking-wide">
            © {new Date().getFullYear()} QUANTALGOLABS
          </p>
          <p className="text-xs font-mono text-cream-dark tracking-wide">
            BUILT WITH ALGORITHMS
          </p>
        </div>
      </div>
    </footer>
  )
}
